import attempt from 'lodash/attempt';
import { LocalDate } from 'js-joda';
import { toLocalDate } from '@lifetools/shared-utils-time';

const specialDateValues = ['today', 'tomorrow'];

export const isValidRouteDate = (date: string): boolean => (
  specialDateValues.includes(date) || attempt(toLocalDate, [ date ]) instanceof LocalDate
);
